import styles from "./PreviewLogin.module.scss"

import React, { MouseEvent } from "react"

import {useLayerPopupContext, useSchedule} from "@shared/contexts"
import {redirectLoginUrl, redirectSignUp} from "../../modules";

const DEFAULT_MESSAGE =
  "공개방송 미리보기가 종료되었습니다.\n지금 바로 로그인하면 방송을 계속 보실 수 있습니다."
const DEFAULT_BUTTON_TEXT = "로그인하기"

function PreviewLogin() {
  const { close, previewLogin } = useLayerPopupContext()
  const { schedule } = useSchedule()

  // 파트너별 설정 문구. 없으면 기본 문구를 사용한다
  const message = previewLogin.message || DEFAULT_MESSAGE
  const buttonText = previewLogin.buttonText || DEFAULT_BUTTON_TEXT

  return (
    <React.Fragment>
      <article className="popup" style={{margin: "-150px 0 0 -250px", width: 500}}>
        <div className="titB">
          <h1>알림</h1>
          <a
            href="#!"
            title="닫기"
            onClick={(e: MouseEvent) => {
              e.preventDefault()
              close()
            }}
          >
            닫기
          </a>
        </div>
        <div className="txtB">
          <div className="roundB">
            <p style={{ whiteSpace: "pre-wrap" }}>{message}</p>
          </div>
        </div>
        <div className="btnB" style={{
          width: "unset"
        }}>
          <a
            href="#!"
            title={buttonText}
            style={{
              width: "auto",
              minWidth: "100px",
              padding: "0 10px"
            }}
            onClick={(e: MouseEvent) => {
              e.preventDefault()

              // 한국경제TV 통합 로그인(SSO). 로그인 후 현재 방송 페이지로 되돌아온다
              if (schedule) {
                redirectLoginUrl(schedule.id)
              }
            }}
          >
            {buttonText}
          </a>
        </div>
        {/*<div className="txtB">*/}
        {/*  <p>아직 와우넷 회원이 아니시면*/}
        {/*    <br />*/}
        {/*    지금 무료 간편가입하고, 빵빵한 가입혜택까지 받아보세요.&nbsp;*/}
        {/*    <a*/}
        {/*      href="#!"*/}
        {/*      style={{textDecoration: "underline"}}*/}
        {/*      title="로그인하기"*/}
        {/*      onClick={(e: MouseEvent) => {*/}
        {/*        e.preventDefault()*/}
        {/*        redirectSignUp()*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      회원가입하기>*/}
        {/*    </a>*/}
        {/*  </p>*/}
        {/*</div>*/}
      </article>
    </React.Fragment>
  )
}

export default PreviewLogin
